import DarkModeIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeIcon from "@mui/icons-material/LightModeOutlined";
import { IconButton, Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useColorMode } from "../contexts/ColorModeContext";

export function ThemeToggle() {
  const { t } = useTranslation("common");
  const { mode, toggle } = useColorMode();
  const isDark = mode === "dark";

  return (
    <Tooltip title={isDark ? t("toggle.light") : t("toggle.dark")}>
      <IconButton
        onClick={toggle}
        aria-label={isDark ? t("toggle.light") : t("toggle.dark")}
        color="inherit"
      >
        {isDark ? <LightModeIcon fontSize="small" /> : <DarkModeIcon fontSize="small" />}
      </IconButton>
    </Tooltip>
  );
}
